export const DayOption = 'day';
